// MAISON DE FAITH — theme scripts
document.addEventListener("DOMContentLoaded", function () {
  // Sound toggles on story videos
  document.querySelectorAll("[data-sound-toggle]").forEach(function (btn) {
    var video = btn.closest(".mdf-media").querySelector("video");
    if (!video) return;
    btn.addEventListener("click", function () {
      var next = !video.muted;
      video.muted = next;
      if (!next) video.play();
      btn.textContent = next ? "SOUND ON" : "SOUND OFF";
    });
  });

  // Hero film — click to start and stop, text steps out while it plays.
  // The film is never preloaded, so the first tap streams it. Show a pulse while it buffers.
  document.querySelectorAll("[data-hero]").forEach(function (hero) {
    var video = hero.querySelector("[data-hero-video]");
    if (!video) return;
    var soundBtn = hero.querySelector("[data-hero-sound]");

    function start() {
      hero.classList.add("is-loading");
      var played = video.play();
      if (played && played.catch) {
        played.catch(function () { hero.classList.remove("is-loading"); });
      }
    }

    function toggle() {
      if (video.paused) { start(); } else { video.pause(); }
    }

    video.addEventListener("playing", function () {
      hero.classList.remove("is-loading");
      hero.classList.add("is-playing");
    });
    video.addEventListener("waiting", function () { hero.classList.add("is-loading"); });
    video.addEventListener("pause", function () {
      hero.classList.remove("is-loading");
      hero.classList.remove("is-playing");
    });

    // Clicking the screen toggles the film. Links and the sound button opt out.
    var screen = hero.querySelector("[data-hero-screen]") || hero;
    screen.addEventListener("click", function (e) {
      if (e.target.closest("a") || e.target.closest("[data-hero-sound]")) return;
      toggle();
    });

    if (soundBtn) {
      soundBtn.addEventListener("click", function () {
        var next = !video.muted;
        video.muted = next;
        if (!next && video.paused) start();
        soundBtn.textContent = next ? "SOUND ON" : "SOUND OFF";
      });
    }
  });

  // Product size selection
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector("[data-add-btn]");
    var buttons = form.querySelectorAll(".mdf-size");
    buttons.forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        if (b.disabled) return;
        buttons.forEach(function (o) { o.removeAttribute("data-active"); });
        b.setAttribute("data-active", "true");
        idInput.value = b.getAttribute("data-variant-id");
        if (addBtn) addBtn.disabled = false;
      });
    });
    form.addEventListener("submit", function (e) {
      if (!idInput.value) {
        e.preventDefault();
        if (addBtn) {
          var label = addBtn.querySelector("span");
          if (label) label.textContent = "SELECT A SIZE FIRST";
          setTimeout(function () { if (label) label.textContent = "ADD TO BAG"; }, 1600);
        }
      }
    });
  });
});
